import { Controller } from 'stimulus';

export default class ExpanderController extends Controller {
  static targets = ['expanderContent', 'viewMore', 'viewLess'];

  toggle(e) {
    const height = e.target.dataset.height;
    this.expanderContentTarget.classList.toggle(height);
    this.viewMoreTarget.classList.toggle('hidden');
    this.viewLessTarget.classList.toggle('hidden');
  }
}
